export enum ContentType {
  Paragraph = 'p',
  Strong = 'strong',
  OrderedList = 'ol',
  UnorderedList = 'ul',
  ListItem = 'li',
  Container = 'div',
  Fragment = 'span',
  Title3 = 'h3',
}

export type ArticleContent = {
  title: string
  content_type?: `${ContentType}`
  content: ArticleContent[] | string[]
  class?: string
}

export type ArticleSection = ArticleContent
